import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { CollaborationReadApiClient, People } from '~/services/Http';
import { TaskStatusEnum } from '~/services/Http/client.people.generated';

export const GET_TEAM_TASKS_SWR_KEY = 'CollaborationReadApiClient.getTeamTasks';

export function useGetTeamTasks(args: {
  employeeId: string;
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order11;
  treeId?: string;
  roles?: string[];
  statuses?: TaskStatusEnum[];
  unitIds?: number[];
}): UseSWROutput<People.TaskDto[]> {
  return useSWR(
    [
      GET_TEAM_TASKS_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.statuses ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([
      _,
      employeeId,
      lang,
      offset,
      limit,
      order,
      treeId,
      statuses,
      unitIds,
      roles,
    ]) =>
      CollaborationReadApiClient.getTeamTasks(
        employeeId,
        order,
        offset,
        limit,
        lang,
        treeId,
        roles,
        statuses,
        unitIds,
      ).then((r) => r.data),
  );
}
